import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { SimpleAlert } from '../../../../../rbts/helpers';
import { SubSeccionModel } from '../models/SubSeccionModel';
import { crearSubSeccion, actualizarSubSeccion } from '../../../../service/boletera/EventosBoletera';

type Props = {
  show: boolean;
  nivelId: number;
  subseccion: SubSeccionModel | null;
  aforoDisponible: number;
  handleClose: (refresh?: boolean) => void;
};

const ModalSubSeccion: React.FC<Props> = ({ show, nivelId, subseccion, aforoDisponible, handleClose }) => {
  const [nombre, setNombre] = useState('');
  const [cantidadBoletos, setCantidadBoletos] = useState('');
  const [saving, setSaving] = useState(false);

  const isEdit = !!subseccion;
  const disponibleConEste = isEdit ? aforoDisponible + (subseccion?.cantidad_boletos || 0) : aforoDisponible;
  const cantidadActual = Number(cantidadBoletos) || 0;
  const excede = cantidadActual > 0 && cantidadActual > disponibleConEste;

  useEffect(() => {
    if (show) {
      setNombre(subseccion?.nombre || '');
      setCantidadBoletos(subseccion ? String(subseccion.cantidad_boletos) : '');
    }
  }, [show, subseccion]);

  const handleSave = async () => {
    if (!nombre.trim()) { SimpleAlert('El nombre es requerido.', 3000, 'error'); return; }
    if (!cantidadBoletos || cantidadActual <= 0) { SimpleAlert('La cantidad de boletos debe ser mayor a 0.', 3000, 'error'); return; }
    if (excede) { SimpleAlert('Excede el aforo disponible del nivel.', 3000, 'error'); return; }
    setSaving(true);
    try {
      if (isEdit) {
        await actualizarSubSeccion(nivelId, subseccion!.id, { nombre: nombre.trim(), cantidad_boletos: cantidadActual });
      } else {
        await crearSubSeccion(nivelId, { nombre: nombre.trim(), cantidad_boletos: cantidadActual });
      }
      handleClose(true);
    } catch (error: any) {
      SimpleAlert(error?.response?.data?.doc?.message || 'Error al guardar.', 3000, 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={() => handleClose()} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">{isEdit ? 'Editar sub-sección' : 'Nueva sub-sección'}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-6 px-8">
        <div className="mb-5">
          <label className="required fw-bold fs-6 mb-2">Nombre</label>
          <input
            className="form-control"
            placeholder="Piso A, Palco 3..."
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
          />
        </div>
        <div className="mb-2">
          <label className="required fw-bold fs-6 mb-2">Cantidad de boletos</label>
          <input
            className={`form-control ${excede ? 'is-invalid' : ''}`}
            type="number"
            min={1}
            value={cantidadBoletos}
            onChange={(e) => setCantidadBoletos(e.target.value)}
          />
          {excede ? (
            <div className="text-danger fs-7 mt-1">
              Excede el aforo disponible ({disponibleConEste.toLocaleString()} boletos).
            </div>
          ) : (
            <div className="text-muted fs-7 mt-1">
              Disponible en el nivel: {disponibleConEste.toLocaleString()} boletos
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-light me-3" onClick={() => handleClose()}>Cancelar</button>
        <button className="btn btn-primary" onClick={handleSave} disabled={saving || excede}>
          {saving ? <><span className="spinner-border spinner-border-sm me-2" />Guardando…</> : 'Guardar'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export { ModalSubSeccion };
